import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { CriterioFormComponent } from 'src/app/pages/criterio-form/criterio-form.component';

@Injectable()
export class CriterioGuard implements CanDeactivate<CriterioFormComponent> {
  canDeactivate(component: CriterioFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}
 
